import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0.15 }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden py-[0.06em]">
          <motion.div
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay: delay + i * 0.13, ease: EASE }}
            className={lineClassName}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </div>
  );
}

export function Counter({ value, suffix = "", decimals = 0, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.2,
      ease: "easeOut",
      onUpdate: (v) => setDisplay(v),
    });
    return () => controls.stop();
  }, [inView, value]);
  return (
    <span ref={ref} className={className}>
      {display.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}
      {suffix}
    </span>
  );
}

export function ChapterHeading({ number, title, sub }) {
  return (
    <Reveal>
      <div className="flex items-start gap-6 mb-14">
        <span className="font-display text-outline text-5xl sm:text-6xl font-800 leading-none select-none" data-testid={`chapter-${number}`}>
          {number}
        </span>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-blurple font-semibold mb-3">Chapter {number}</p>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">{title}</h2>
          {sub && <p className="text-muted-foreground mt-3 max-w-xl text-base md:text-lg">{sub}</p>}
        </div>
      </div>
    </Reveal>
  );
}
